import { Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { UrlApi } from '../../services/apirest';

function CambiaVehiculo(props) {
    const [vehiculo, setVehiculo] = useState();
    const [vehiculoelegido, setVehiculoelegido] = useState(localStorage.getItem("patente"));

    const handleChange = async (event) => {
        await setVehiculoelegido(event.target.value);

    };

    useEffect(() => {
        const buscardatos = async () => {
            const data = await fetch(
                UrlApi + "/viajest1/vehiculos"
            )
            const datav = await data.json()
            setVehiculo(datav)
            datav && console.log(datav)
        }
        buscardatos()
    }, [])

    useEffect(() => {
        localStorage.setItem("patente", vehiculoelegido)
        console.log(vehiculoelegido)
    }, [vehiculoelegido])

    const cerraresto = () => {
        props.cerrar(false)
    }

    return (
        <div>
            <div style={{ textAlign: "center", color: "green" }}>
                <br></br>
                <br></br>
                <br></br>
                <h2>Cambiar vehiculo</h2>
            </div>
            <div style={{ textAlign: "center" }}>
                <FormControl sx={{ m: 1, minWidth: 200 }}>
                    <InputLabel id="demo-simple-select-label">
                        Dominio
                    </InputLabel>
                    <Select
                        value={vehiculoelegido}
                        label="Patente"
                        onChange={handleChange}
                        defaultValue=""
                    >
                        {vehiculo ? vehiculo.map(item =>
                            <MenuItem key={item.id} value={item.patente}>{item.patente}</MenuItem>
                        ) : null}

                    </Select>
                    <Button onClick={cerraresto}>Listo</Button>
                </FormControl>
            </div>
        </div>
    );
}

export default CambiaVehiculo